import { useState } from 'react';

type SuggestionsMode = 'itinerary' | 'packages';

type AiSuggestionsUiState = {
  status: 'idle' | 'loading' | 'error';
  requestMode: SuggestionsMode | null;
  error: string | null;
  errorMode: SuggestionsMode | null;
  extended: boolean;
};

export function useAiSuggestionsUiState() {
  const [aiSuggestionsUi, setAiSuggestionsUi] = useState<AiSuggestionsUiState>({
    status: 'idle',
    requestMode: null,
    error: null,
    errorMode: null,
    extended: false,
  });

  const setAiSuggestionsRequestMode = (mode: SuggestionsMode | null) => {
    setAiSuggestionsUi((prev) => ({ ...prev, requestMode: mode }));
  };

  const setAiSuggestionsLoadingExtended = (extended: boolean) => {
    setAiSuggestionsUi((prev) => ({
      ...prev,
      extended: prev.status === 'loading' ? extended : false,
    }));
  };

  const setAiSuggestionsError = (error: string | null) => {
    setAiSuggestionsUi((prev) => {
      if (!error) {
        return prev.status === 'error' ? { ...prev, status: 'idle', error: null, errorMode: null } : { ...prev, error: null };
      }
      return { ...prev, status: 'error', error, extended: false };
    });
  };

  const setAiSuggestionsErrorMode = (mode: SuggestionsMode | null) => {
    setAiSuggestionsUi((prev) => ({ ...prev, errorMode: mode }));
  };

  const setAiSuggestionsLoading = (loading: boolean) => {
    setAiSuggestionsUi((prev) => {
      if (!loading) {
        return { ...prev, status: prev.status === 'loading' ? 'idle' : prev.status, extended: false };
      }
      return { ...prev, status: 'loading', error: null, errorMode: null, extended: false };
    });
  };

  return {
    aiSuggestionsLoading: aiSuggestionsUi.status === 'loading',
    aiSuggestionsLoadingExtended: aiSuggestionsUi.status === 'loading' && aiSuggestionsUi.extended,
    aiSuggestionsError: aiSuggestionsUi.status === 'error' ? aiSuggestionsUi.error : null,
    aiSuggestionsErrorMode: aiSuggestionsUi.errorMode,
    aiSuggestionsRequestMode: aiSuggestionsUi.requestMode,
    setAiSuggestionsLoading,
    setAiSuggestionsError,
    setAiSuggestionsErrorMode,
    setAiSuggestionsLoadingExtended,
    setAiSuggestionsRequestMode,
  };
}
